import { StateV16 } from './16_migrate_elementar_vorschaeden.interface';

export const migrateElementarVorschaeden = (
  previousState: StateV16,
  newVersion: number,
): StateV16 => {
  return {
    ...previousState,
    vorschaeden: previousState.vorschaeden
      ? { ...previousState.vorschaeden, elementar: previousState.vorschaeden.elementar ?? 0 }
      : previousState.vorschaeden,
    version: newVersion,
  };
};
